export default __webpack_public_path__ + "static/media/heroCta.154cbe8f.svg";